import { useEffect, useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { CalendarDays } from "lucide-react";

const KIND_LABELS = { sale: "de la facture", order: "de l'achat", transfer: "du transfert" };
const toDay = (d) => (d ? new Date(d).toISOString().slice(0, 10) : "");

// Modifier la date d'un document (vente, achat / entrée en stock, transfert) — admin et gérant
export const DateChangeDialog = ({ doc, kind, onOpenChange, onSaved }) => {
  const [date, setDate] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { if (doc) setDate(toDay(doc.created_at)); }, [doc]);
  const save = async () => {
    setSaving(true);
    try {
      await api.patch(`/documents/${kind}/${doc.id}/date`, { date });
      toast.success(`Date ${KIND_LABELS[kind]} ${doc.number} modifiée`);
      onOpenChange(false); onSaved?.();
    } catch (e) { toast.error(e.response?.data?.detail || "Erreur lors de la modification de la date"); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!doc} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="date-change-dialog">
        <DialogHeader><DialogTitle className="font-[Chivo] flex items-center gap-2"><CalendarDays className="w-5 h-5 text-blue-700" /> Modifier la date {KIND_LABELS[kind]}</DialogTitle></DialogHeader>
        {doc && (
          <div className="space-y-3">
            <p className="text-sm text-slate-600">Document <span className="font-mono font-bold text-slate-900">{doc.number}</span> — date actuelle : <span className="font-medium">{new Date(doc.created_at).toLocaleDateString("fr-FR")}</span></p>
            <div><Label className="overline">Nouvelle date</Label><Input type="date" value={date} max={new Date().toISOString().slice(0, 10)} onChange={(e) => setDate(e.target.value)} onKeyDown={(e) => e.key === "Enter" && date && save()} className="rounded-sm h-9" data-testid="date-change-input" /></div>
            <p className="text-xs text-slate-500">L'heure d'origine est conservée. Le stock, les relevés et la comptabilité suivent la nouvelle date.</p>
            <div className="flex justify-end gap-2"><Button variant="outline" className="rounded-sm" onClick={() => onOpenChange(false)}>Annuler</Button><Button className="btn-accent" disabled={!date || saving} onClick={save} data-testid="date-change-submit">Enregistrer</Button></div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
